import { NameHelper, NameHelperFormat } from "@/Common/Helpers/NameHelper";
import { Person } from "@/Common/Models/Person/Person";
import * as LocalOperations from "@/Common/Operations/operations.local";

class OpenPatientsDropdownState {
    public persons: Person[];
    public activePersonContactId?: string;
}

interface IOpenPatientsDropdownProps {
    onSelectCallback?(s?: string): void;
}

class OpenPatientsDropdown extends React.Component<IOpenPatientsDropdownProps, OpenPatientsDropdownState> {
    private sessionStorelistenerRef: string;

    public constructor(props: IOpenPatientsDropdownProps) {
        super(props);

        this.state = {
            persons: sessionStore.selectedFilesHistory.slice().reverse(),
            activePersonContactId: sessionStore.selectedFile?.ContactId
        };
    }

    public componentDidMount(): void {
        this.sessionStorelistenerRef = sessionStore.AddChangeListener(this.onStoreChanged, this, "open-patient-dropdown");
    }

    public render(): JSX.Element {
        return (
            <div className="popup open-patients" onClick={this.stopPropagation.bind(this)}>
                <ul className="patient-list">
                    {this.state.persons.map((person: Person) => {
                        const activeCss = person.ContactId === this.state.activePersonContactId ? "selected" : null;
                        return (
                            <li key={`openFile_${person.ContactId}`} className={activeCss} onClick={() => this.selectActiveFile(person)}>
                                {NameHelper.formatFullName(person.FirstName, person.LastName.toUpperCase(), person.PreferredName, NameHelperFormat.UpperLastNameFirst)}
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private onStoreChanged(): void {
        this.setState({
            persons: sessionStore.selectedFilesHistory.slice().reverse(),
            activePersonContactId: sessionStore.selectedFile?.ContactId
        });
    }

    public componentWillUnmount(): void {
        sessionStore.RemoveChangeListener(this.sessionStorelistenerRef);
    }

    private selectActiveFile(person: Person): void {
        sessionStore.dispatch(LocalOperations.Person.OpenFile, { person: person });
        this.props.onSelectCallback?.();
    }
}

export { OpenPatientsDropdown };
